import { TFunction } from "i18next"
import { TagsSetTag } from "shared/components/cards/components/TagsSet/types"

export const newTag = (t: TFunction): TagsSetTag => ({ title: t("shared:newCourse"), variant: "filled" })

export const highlightTag = (t: TFunction): TagsSetTag => ({ title: t("shared:highlight"), variant: "filled" })

export const EXTERNAL_CERTIFICATE_INFO_URL =
  "https://www.kbv.de/praxis/tools-und-services/praxisnachrichten/2026/03-19/verguetung-fuer-lungenkrebs-screening-beschlossen"

// TODO: replace with the real price once the Stripe product for the lung cancer screening certificate exists
export const EXTERNAL_CERTIFICATE_PRICE = 50

export const COURSE_TYPE_TRANSFORMER = Object.freeze({
  basicCourse: "course",
  expertCourse: "course",
  guidelineCourse: "course",
  videoCasts: "course",
  medudyShorts: "singleShortVideo",
  shortUnit: "singleShortVideo",
  journal: "singleShortVideo",
})
